module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\r\n<div class="form-row col-12">\r\n    <div class="form-group col-12">\r\n        <label for="delegue.matricule">'+
((__t=(i18n.t("droitsdel.droitsDelegues")))==null?'':__t)+
'</label>\r\n        <span class="droisDeleguesA"></span>\r\n    </div>\r\n</div>\r\n\r\n<div class="form-row col-12">\r\n    <div class="form-group col-12">\r\n        <label for="retro sr-only"></label>\r\n        <span class="radioRetro"></span>\r\n    </div>\r\n</div>\r\n<div class="form-row col-12">\r\n    <div class="form-group col">\r\n        <div class="customFilterButtonsContainer d-flex justif-content-end"></div>\r\n    </div>\r\n</div>\r\n\r\n';
}
return __p;
};
